module.exports = __webpack_public_path__ + "static/media/Pattern10.5307d128.png";